import socketIOClient from "socket.io-client";
export function socketConfig(endpoint) {
    const socket = socketIOClient(endpoint,{transports: ['websocket'] });
    return socket;
}
